import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/Layout/Layout'
import ScrollToTop from './components/ScrollToTop/ScrollToTop'
import Home from './pages/Home/Home'
import Contact from './pages/Contact/Contact'

/**
 * Home carries the whole advisory narrative; the old About page folded into
 * it, so /about lands on #who-we-are. The old Weebly URLs are redirected at the edge by
 * public/staticwebapp.config.json, and again here in case a build is served
 * from somewhere that ignores that file. /news no longer has a page.
 */
function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />

          <Route path="/about" element={<Navigate to="/#who-we-are" replace />} />
          <Route path="/about-us.html" element={<Navigate to="/#who-we-are" replace />} />
          <Route path="/news" element={<Navigate to="/" replace />} />
          <Route path="/news-and-events.html" element={<Navigate to="/" replace />} />
          <Route path="/contact.html" element={<Navigate to="/contact" replace />} />
          <Route path="/index.html" element={<Navigate to="/" replace />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </Router>
  )
}

export default App
